export default function setToastSlice(title = '', description = '', type = 'info') {
	return (dispatch) => {
		dispatch({
			type: 'SET_TOAST_SLICE',
			payload: {title, description, type},
		});
	};
}